import api from './api';

export interface DemoRequestData {
  name: string;
  institute: string;
  email: string;
  contactNumber: string;
}

export interface DemoRequest extends DemoRequestData {
  _id: string;
  status: 'pending' | 'contacted' | 'completed' | 'cancelled';
  notes?: string;
  createdAt: string;
  updatedAt: string;
}

export interface DemoRequestStats {
  total: number;
  pending: number;
  contacted: number;
  completed: number;
  cancelled: number;
}

// Public API - Create a new demo request
export const createDemoRequest = async (data: DemoRequestData) => {
  const response = await fetch(`${process.env.REACT_APP_API_URL || 'http://localhost:5000/api'}/demo-requests`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(data),
  });

  if (!response.ok) {
    const error = await response.json();
    throw new Error(error.message || 'Failed to submit demo request');
  }

  return response.json();
};

// Admin APIs - Require authentication
export const getAllDemoRequests = async (params?: { status?: string; page?: number; limit?: number }) => {
  const queryParams = new URLSearchParams();
  if (params?.status) queryParams.append('status', params.status);
  if (params?.page) queryParams.append('page', params.page.toString());
  if (params?.limit) queryParams.append('limit', params.limit.toString());

  const response = await api.get(`/demo-requests?${queryParams.toString()}`);
  return response.data;
};

export const getDemoRequestById = async (id: string) => {
  const response = await api.get(`/demo-requests/${id}`);
  return response.data;
};

export const updateDemoRequest = async (id: string, data: { status?: string; notes?: string }) => {
  const response = await api.put(`/demo-requests/${id}`, data);
  return response.data;
};

export const deleteDemoRequest = async (id: string) => {
  const response = await api.delete(`/demo-requests/${id}`);
  return response.data;
};

export const getDemoRequestStats = async () => {
  const response = await api.get('/demo-requests/stats');
  return response.data;
};

